export default function councilReducer(state = [], action) {
  switch (action.type) {
    case "FETCH_COUNCIL":
      return [].concat.apply([], [...state, action.payload]);
    default:
      return state;
  }
}
